import { useDispatch } from 'react-redux';
import {
  startGoogleLogin,
  setFormError,
  emailSignInStart,
} from '../../redux/Auth/auth.actions';

import { setToastrTxt } from "../../redux/Cart/cart.actions";

const useSocialLoginFacade = () => {
  const dispatch = useDispatch();

  const loginWithGoogle = (response) => {
    if (response?.profileObj?.email) {
      const socialUser = {
        email: response.profileObj.email,
        first_name: response.profileObj.givenName,
        last_name: response.profileObj.familyName,
        token: response.tokenId,
        "social-id": response.googleId,
        social_name: "gmail",
      };

      dispatch(startGoogleLogin(socialUser));
    } else {
      console.error("Google Login Failed");
    }
  };

  const loginWithEmail = ({ email, password }) => {

    if (!email || !password) {
      dispatch(setToastrTxt({
        title: "Login",
        txt: "Por favor, preencha email e senha.",
        err: true,
      }));
      return;
    }
    dispatch(emailSignInStart({ email, password }));
  };

  const clearFormError = () => dispatch(setFormError());

  return { loginWithGoogle, loginWithEmail, clearFormError };
};

export default useSocialLoginFacade;
